<template>
  <router-view />
</template>

<script>

export default {
  name: 'PriceWrapper'
}
</script>
